import { AbstractModel } from "./abstract-model";
import { Classificacao } from "./registro-produto";

export class HabilEmpresarialProduto extends AbstractModel {
  nomeProduto: string;
  codigo: string;
  mod: string;
  classificacao: Classificacao;
    
  empresas: number = 0;
  boletos: number = 0;
  nfes: number = 0;
  nfces: number = 0;
  nfses: number = 0;
  
  rotinas: any[]
}

export class HabilEmpresarialRotina extends AbstractModel {
  nome: string;
  categoria: string;
  tela: string;
  codigo: string;
}

export class HabilEmpresarialRegistroLicenca {
  nome: string;
  cnpj: string;
  val: Date = new Date();
  chave: string;
  users: number = 1;
  nomeSolucao: string;
  versao: string = '9.8';
  mod: string;
  cf: boolean = false;
  contrato: boolean = false;
  compras: boolean = false;
  almoxarifado: boolean = false;
  magento: boolean = false;
  extra: string[] = [];
  nfe: boolean = false;
  vNfe: string = '4.16';
  nfce: boolean = false;
  nfse: boolean = false;
  sat: boolean = false;
  nfeCnpjs: string[] = [];
  nfceCnpjs: string[] = [];
  nfseCnpjs: string[] = [];
  satCnpjs: string[] = [];
  acessos: number[] = [];

  empresas: number = 0;
  boletos: number = 0;
  nfes: number = 0;
  nfces: number = 0;
  nfses: number = 0;

  trial: number = 0;
}